import {AfterViewInit, Component, Input} from '@angular/core';
import * as Highcharts from 'highcharts/highstock';
import series_label from 'highcharts/modules/series-label';
import sankey from 'highcharts/modules/sankey'
import theme from 'highcharts/themes/grid-light';
import {high_colors} from "../../charts/general-chart/general-chart.component";
import { ChartPlaceholderComponent } from "../chart-placeholder/chart-placeholder.component";
import { HighchartsChartComponent } from "highcharts-angular";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sankey-chart',
  templateUrl: './sankey-chart.component.html',
  styleUrls: ['./sankey-chart.component.scss'],
  imports: [ChartPlaceholderComponent, HighchartsChartComponent, CommonModule],
  standalone: true,
})
export class SankeyChartComponent implements AfterViewInit {
  chartInstance: Highcharts.Chart;
  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor = 'chart';
  chartOptions: Highcharts.Options = {};

  @Input() rbics: any[] = [];
  @Input() companyName: string = '';

  loaded = false;

  rbicsData: any[] = [];

  constructor() { 
    if (typeof Highcharts === 'object') {
      (theme as any)(Highcharts as any);
      (series_label as any)(Highcharts as any);
      (sankey as any)(Highcharts as any);
    }
  }

  ngAfterViewInit(): void {
    this.initSankeyData()
    this.initChart()
  }

  initSankeyData() {
    this.rbicsData = [
      ...this.sumGroup('l1_name', 'l2_name', 1),
      ...this.sumGroup('l2_name', 'l3_name', 2),
      ...this.sumGroup('l3_name', 'l4_name', 3),
      ...this.sumGroup('l4_name', 'l5_name', 4),
      ...this.sumGroup('l5_name', 'l6_name', 5),
    ];
  }

  sumGroup(from, to, suffix) {
    let result = [];
    this.rbics.reduce(function(res, value) {
      if (!res[`L${suffix}-${value[from]}-L${suffix+1}-${value[to]}`]) {
        res[`L${suffix}-${value[from]}-L${suffix+1}-${value[to]}`] = { from: `L${suffix} - ${value[from]}`, to: `L${suffix+1} - ${value[to]}`, weight: 0};
        result.push(res[`L${suffix}-${value[from]}-L${suffix+1}-${value[to]}`])
      }
      res[`L${suffix}-${value[from]}-L${suffix+1}-${value[to]}`].weight += value.revenue_pct;
      return res;
    }, {});
    return result;
  }

  initChart() {
    this.chartOptions = {
      chart: {
        height: '350px'
      },
      credits: {
        enabled: false
      },
      colors: high_colors,
      title: {
        text: ''
      },
      navigator: {
        enabled: false
      },
      scrollbar: {
        enabled: false
      },
      yAxis: {
        minorTickInterval: 0.5,
        minorGridLineWidth: 0,
      },
      legend: {
        enabled: true,
      },
      tooltip: {
        valueDecimals: 2,
        valueSuffix: '%',
        pointFormatter: function() {
          let that: any = this;
          return that.from + ' - ' + that.to + ': ' + '<strong>' + that.weight + '%' + '</strong>'
        }
      },
      series: [{
        keys: ['from', 'to', 'weight'],
        data: this.rbicsData,
        type: 'sankey',
        name: this.companyName,
      }],
      plotOptions: {
        series: {
          lineWidth: 2,
          label: {
            enabled: true,
          }
        },
        sankey: {
          nodePadding: 20,
          nodeWidth: 10,
          dataLabels: {
            allowOverlap: false,
            crop: true,
            enabled: true,
            color: '#ffffff',
            style: {
              fontSize: '14px',
              fontWeight: 'bold',
              textShadow: false,
              textOutline: 'none'
            }
          }
        }
      },
    };
    setTimeout(() => {
      this.loaded = true
    }, 100)
  }
}
